export default __webpack_public_path__ + "static/media/login_background.a587877e.jpg";